var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar",style:({ opacity: _vm.routing && _vm.show ? 1 : 0 }),attrs:{"role":"progressbar","aria-valuenow":_vm.aProgress,"aria-valuemin":"0","aria-valuemax":"100"}},[(_vm.routing && _vm.show)?_c('div',{staticClass:"progress",style:({ width: `${_vm.aProgress}%` })}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }